import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map, Observable } from "rxjs";
import {
  EmployeeSetting,
  PredefinedEmployeeSetting,
} from "./settings.interface";

function isContactVariable(name: string): boolean {
  const lower = name.toLowerCase();
  return (
    lower.includes("phone") ||
    lower.includes("mobile") ||
    lower.includes("email")
  );
}

@Injectable({ providedIn: "root" })
export class SettingsService {
  constructor(private http: HttpClient) {}

  getCustomLabelVariableOptions(): Observable<string[]> {
    return this.http
      .get<{ customLabelVariableOptions?: string[] }>("/template/placeholders")
      .pipe(
        map((res) => {
          const all = res?.customLabelVariableOptions ?? [];
          return all.filter((name) => !isContactVariable(name));
        }),
      );
  }

  getPredefinedEmployeeSettings(): Observable<PredefinedEmployeeSetting[]> {
    return this.http.get<PredefinedEmployeeSetting[]>(
      "/signature-variables-predefined",
    );
  }

  getEmployeeSettings(mine?: boolean): Observable<EmployeeSetting[]> {
    return this.http.get<EmployeeSetting[]>("/signature-variables", {
      params: mine ? { mine: "true" } : undefined,
    });
  }

  changeEmployeeSettings(
    payload: EmployeeSetting[],
  ): Observable<Record<string, unknown>> {
    return this.http.put<Record<string, unknown>>(
      "/signature-variables",
      payload,
    );
  }

  listPrintCardOrderApprovers(): Observable<{
    approvers: Array<{
      email: string;
      role: string;
      givenName: string | null;
      familyName: string | null;
      fullName: string | null;
    }>;
  }> {
    return this.http.get<{
      approvers: Array<{
        email: string;
        role: string;
        givenName: string | null;
        familyName: string | null;
        fullName: string | null;
      }>;
    }>("/settings/print-card-order-approvers");
  }
}
